import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
} from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import { getTotalAttendanceByPeriodRequest } from "../../../modules/admin-modules/reports/Actions";

const nextDayStart = (dateStr) => {
  const date = new Date(`${dateStr}T00:00:00`);
  date.setDate(date.getDate() + 1);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day} 00:00:00`;
};

const TotalAttendanceByPeriodReport = () => {
  const dispatch = useDispatch();
  const rows = useSelector((state) => state.reports.totalAttendanceByPeriod);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [size, setPerPage] = useState(15);

  const handleFetch = () => {
    if (!from || !to) {
      toast.error("حدد تاريخ البداية والنهاية");
      return;
    }
    if (from > to) {
      toast.error("تاريخ البداية يجب أن يكون قبل تاريخ النهاية");
      return;
    }
    setPageNumber(0);
    dispatch(
      getTotalAttendanceByPeriodRequest({
        from: `${from} 00:00:00`,
        to: nextDayStart(to),
      })
    );
  };

  const Data = useMemo(
    () =>
      (Array.isArray(rows) ? rows : []).map((row, index) => ({
        ...row,
        index: `#${index + 1}`,
        student_id: row?.student_id ?? "",
        student_name: row?.student_name ?? "",
        subject_name: row?.subject_name ?? "",
        group_name: row?.group_name ?? "",
        student_phone: row?.student_phone ?? "",
        parent_phone: row?.parent_phone ?? "",
        total_attended_classes: row?.total_attended_classes ?? 0,
      })),
    [rows]
  );

  const columns = [
    { Header: "#", accessor: "index" },
    { Header: "كود الطالب", accessor: "student_id" },
    { Header: "اسم الطالب", accessor: "student_name" },
    { Header: "المادة", accessor: "subject_name" },
    { Header: "المجموعة", accessor: "group_name" },
    { Header: "رقم الطالب", accessor: "student_phone" },
    { Header: "رقم ولي الأمر", accessor: "parent_phone" },
    { Header: "عدد أيام الحضور", accessor: "total_attended_classes" },
  ];

  const exportToExcel = () => {
    if (!Data.length) {
      toast.error("لا توجد بيانات للتصدير");
      return;
    }

    const sheetData = Data.map((row) => ({
      "#": row.index,
      "كود الطالب": row.student_id,
      "اسم الطالب": row.student_name,
      المادة: row.subject_name,
      المجموعة: row.group_name,
      "رقم الطالب": row.student_phone,
      "رقم ولي الأمر": row.parent_phone,
      "عدد أيام الحضور": row.total_attended_classes,
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    worksheet["!cols"] = [
      { width: 8 },
      { width: 14 },
      { width: 28 },
      { width: 24 },
      { width: 24 },
      { width: 18 },
      { width: 18 },
      { width: 18 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(
      workbook,
      `total-attendance-${from || "from"}-${to || "to"}.xlsx`
    );
  };

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
          flexWrap="wrap"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            إجمالي الحضور حسب الفترة
          </Text>
          <Flex alignItems="center" gap={3} flexWrap="wrap">
            <Button
              bg="main_1"
              color="white"
              onClick={exportToExcel}
              isDisabled={!Data.length}
            >
              تصدير Excel
            </Button>
            <LogoutMenu />
          </Flex>
        </Flex>

        <Box mb={6} p={4} bg="gray.50" borderRadius="md">
          <Text fontSize="16px" fontWeight="500" mb={4}>
            حدد الفترة
          </Text>
          <Flex gap={4} alignItems="end" flexWrap="wrap">
            <FormControl maxW="280px">
              <FormLabel>من</FormLabel>
              <Input
                type="date"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </FormControl>
            <FormControl maxW="280px">
              <FormLabel>إلى</FormLabel>
              <Input
                type="date"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </FormControl>
            <Button
              bg="main_1"
              color="white"
              onClick={handleFetch}
              isLoading={isLoading}
              isDisabled={!from || !to}
            >
              عرض التقرير
            </Button>
          </Flex>
        </Box>

        <CTable
          selectedData={() => {}}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={() => {}}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={1}
        />
      </div>
    </Layout>
  );
};

export default TotalAttendanceByPeriodReport;
